import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { sanitizeDocument } from '../security';

/**
 * Prepares author-supplied html for an isolated `<iframe srcdoc>`, keeping the document's own
 * `<style>` working. Use this where the content styles itself; use `aixSanitize` where it should
 * inherit the app's styling instead.
 *
 * Bind it only to `srcdoc`, and only on a frame sandboxed without `allow-scripts`.
 */
@Pipe({
    name: 'aixSanitizeDocument',
    standalone: true
})
export class AixSanitizeDocumentPipe implements PipeTransform {
    constructor(private domSanitizer: DomSanitizer) {}

    transform(html: string) {
        // Angular treats `srcdoc` as an html binding, and its own sanitizer would strip the
        // `<style>` back out -- the whole point of this path. sanitizeDocument has already run.
        return this.domSanitizer.bypassSecurityTrustHtml(sanitizeDocument(html));
    }
}
